import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router';
import { isAuthorized } from '../../../util/session';

import QuoteRequestSignUpFormContainer from '../../quote/QuoteRequestSignUpFormContainer';
import QuoteRequestSignUpFormAContainer from '../../quote/QuoteRequestSignUpFormAContainer';

class SignQuoteContainer extends Component {
  render() {
    return (
      <div className="dashboard-container">
        <Switch>
          <Route
            exact
            path="/p1/:productId"
            render={() => {
              return isAuthorized() ? (
                <Redirect to={'/p/' + this.props.match.params.productId} />
              ) : (
                <QuoteRequestSignUpFormContainer />
              );
            }}
          />
          <Route
            exact
            path="/p2/:productId"
            render={() => {
              return isAuthorized() ? (
                <Redirect to={'/p/' + this.props.match.params.productId} />
              ) : (
                <QuoteRequestSignUpFormAContainer />
              );
            }}
          />
        </Switch>
      </div>
    );
  }
}

export default SignQuoteContainer;



// WEBPACK FOOTER //
// ./src/container/sign/SignQuoteContainer/index.js